import {
  ApiBlueprint,
  PageBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { mdiScatterPlot } from '@mdi/js';
import Icon from '@mdi/react';
import {
  rootRouteRef,
  modelsListRouteRef,
  sessionDetailsRouteRef,
  modelDetailsRouteRef,
} from './routes';
import { agaSessionsApiRef } from './types';
import { AGASessionsClient } from './api';

// ── API (→ global API registry) ─────────────────────────
const graphAnalyticsApi = ApiBlueprint.make({
  name: 'graph-analytics-api',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: agaSessionsApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
        },
        factory: ({ discoveryApi, fetchApi }) =>
          new AGASessionsClient({ discoveryApi, fetchApi }),
      }),
    ),
});

// ── Routes (→ app/routes) ───────────────────────────────
const listPage = PageBlueprint.make({
  params: {
    title: 'Graph Analytics',
    icon: <Icon path={mdiScatterPlot} size="20px" />,
    path: '/graph-analytics',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/SessionsListPage').then(m => <m.SessionsListPage />),
  },
});

const modelsListPage = PageBlueprint.make({
  name: 'models-list',
  params: {
    title: 'Graph Analytics',
    icon: <Icon path={mdiScatterPlot} size="20px" />,
    path: '/graph-analytics/models',
    routeRef: modelsListRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/ModelsListPage').then(m => <m.ModelsListPage />),
  },
});

const detailPage = PageBlueprint.make({
  name: 'detail',
  params: {
    path: '/graph-analytics/sessions/:sessionId',
    routeRef: sessionDetailsRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/SessionDetailsPage').then(m => (
        <m.SessionDetailsPage />
      )),
  },
});

const modelDetailPage = PageBlueprint.make({
  name: 'model-detail',
  params: {
    path: '/graph-analytics/models/:modelId',
    routeRef: modelDetailsRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/ModelDetailsPage').then(m => <m.ModelDetailsPage />),
  },
});

export default createFrontendPlugin({
  info: {
    packageJson: () => import('../package.json'),
    manifest: () => import('../catalog-info.yaml'),
  },
  pluginId: 'neo4j-graph-analytics',
  extensions: [
    graphAnalyticsApi,
    listPage,
    modelsListPage,
    detailPage,
    modelDetailPage,
  ],
  routes: {
    root: rootRouteRef,
    modelsList: modelsListRouteRef,
    sessionDetails: sessionDetailsRouteRef,
    modelDetails: modelDetailsRouteRef,
  },
});
